export {default} from './Score'



// WEBPACK FOOTER //
// ./src/UI/Score/index.js